<template>
  <SMDrawingMenu ref="menuRef" class="fixed top-1/3 left-2 -translate-y-1/2">
    <SMDrawingMenuItem
      icon="photo_size_select_large"
      title="Selection"
      :active="drawingMode === DRAWINGMODE.MAIN"
      @click="setDrawingMode(DRAWINGMODE.MAIN, true)"
    />
    <SMDrawingMenuItem
      v-if="isDrawingRowsEnabled && isEventDraftOrPaused"
      title="Rows"
      icon="dialpad"
      :active="drawingMode === DRAWINGMODE.ROWS"
      @click="setDrawingMode(DRAWINGMODE.ROWS)"
    />
    <SMDrawingMenuItem v-if="isDrawingTablesEnabled && isEventDraftOrPaused" title="Tables" icon="bubble_chart">
      <SMDrawingMenuItem
        icon="radio_button_unchecked"
        title="Rounded"
        :active="drawingMode === DRAWINGMODE.TABLE.ROUNDED"
        @click="setDrawingMode(DRAWINGMODE.TABLE.ROUNDED)"
      />
      <SMDrawingMenuItem
        icon="check_box_outline_blank"
        title="Rectangular"
        :active="drawingMode === DRAWINGMODE.TABLE.RECTANGULAR"
        @click="setDrawingMode(DRAWINGMODE.TABLE.RECTANGULAR)"
      />
    </SMDrawingMenuItem>

    <SMDrawingMenuItem v-if="isDrawingSectionsEnabled && isEventDraftOrPaused" title="Sections" icon="blur_on">
      <SMDrawingMenuItem
        icon="panorama_fish_eye"
        title="Rounded"
        :active="drawingMode === DRAWINGMODE.SECTION.ROUNDED"
        @click="setDrawingMode(DRAWINGMODE.SECTION.ROUNDED)"
      />
      <SMDrawingMenuItem
        icon="crop_din"
        title="Rectangular"
        :active="drawingMode === DRAWINGMODE.SECTION.RECTANGULAR"
        @click="setDrawingMode(DRAWINGMODE.SECTION.RECTANGULAR)"
      />
      <SMDrawingMenuItem
        icon="share"
        title="Polygonal"
        :active="drawingMode === DRAWINGMODE.SECTION.POLYGONAL"
        @click="setDrawingMode(DRAWINGMODE.SECTION.POLYGONAL)"
      />
      <SMDrawingMenuItem
        icon="conversion_path"
        title="Path"
        :active="drawingMode === DRAWINGMODE.SECTION.PATH"
        @click="setDrawingMode(DRAWINGMODE.SECTION.PATH)"
      />
    </SMDrawingMenuItem>
    <SMDrawingMenuItem
      v-if="isDrawingRowsEnabled && isEventDraftOrPaused && !isInsideZoneLayout"
      title="General Admission"
      icon="data_usage"
    >
      <SMDrawingMenuItem
        icon="panorama_fish_eye"
        title="Rounded"
        :active="drawingMode === DRAWINGMODE.GA.ROUNDED"
        @click="setDrawingMode(DRAWINGMODE.GA.ROUNDED)"
      />
      <SMDrawingMenuItem
        icon="crop_din"
        title="Rectangular"
        :active="drawingMode === DRAWINGMODE.GA.RECTANGULAR"
        @click="setDrawingMode(DRAWINGMODE.GA.RECTANGULAR)"
      />
      <SMDrawingMenuItem
        icon="share"
        title="Polygonal"
        :active="drawingMode === DRAWINGMODE.GA.POLYGONAL"
        @click="setDrawingMode(DRAWINGMODE.GA.POLYGONAL)"
      />
    </SMDrawingMenuItem>
    <SMDrawingMenuItem
      v-if="isEventDraftOrPaused"
      title="Text"
      icon="text_fields"
      :active="drawingMode === DRAWINGMODE.TEXT"
      @click="setDrawingMode(DRAWINGMODE.TEXT)"
    />
    <SMDrawingMenuItem v-if="isEventDraftOrPaused" icon="star_border" title="Shapes">
      <SMDrawingMenuItem title="Basic Shapes" icon="signal_cellular_null">
        <SMDrawingMenuItem
          title="Line"
          icon="remove"
          :active="drawingMode === DRAWINGMODE.SHAPES.SIMPLE.LINE"
          @click="setDrawingMode(DRAWINGMODE.SHAPES.SIMPLE.LINE)"
        />
        <SMDrawingMenuItem
          title="Circle"
          icon="panorama_fish_eye"
          :active="drawingMode === DRAWINGMODE.SHAPES.SIMPLE.CIRCLE"
          @click="setDrawingMode(DRAWINGMODE.SHAPES.SIMPLE.CIRCLE)"
        />
        <SMDrawingMenuItem
          title="Rectangle"
          icon="crop_din"
          :active="drawingMode === DRAWINGMODE.SHAPES.SIMPLE.RECT"
          @click="setDrawingMode(DRAWINGMODE.SHAPES.SIMPLE.RECT)"
        />
        <SMDrawingMenuItem
          title="Polygon"
          icon="share"
          :active="drawingMode === DRAWINGMODE.SHAPES.SIMPLE.POLYGON"
          @click="setDrawingMode(DRAWINGMODE.SHAPES.SIMPLE.POLYGON)"
        />
      </SMDrawingMenuItem>
      <SMDrawingMenuItem icon="star" title="Icons">
        <SMDrawingMenuItem
          title="Food"
          icon="restaurant"
          :active="drawingMode === DRAWINGMODE.SHAPES.PREDEFINED.FOOD"
          @click="setDrawingMode(DRAWINGMODE.SHAPES.PREDEFINED.FOOD)"
        />
        <SMDrawingMenuItem
          title="Bar"
          icon="local_bar"
          :active="drawingMode === DRAWINGMODE.SHAPES.PREDEFINED.BAR"
          @click="setDrawingMode(DRAWINGMODE.SHAPES.PREDEFINED.BAR)"
        />
        <SMDrawingMenuItem
          title="Exit"
          icon="directions_run"
          :active="drawingMode === DRAWINGMODE.SHAPES.PREDEFINED.EXIT"
          @click="setDrawingMode(DRAWINGMODE.SHAPES.PREDEFINED.EXIT)"
        />
        <SMDrawingMenuItem
          title="Bathrooms"
          icon="wc"
          :active="drawingMode === DRAWINGMODE.SHAPES.PREDEFINED.BATHROOM"
          @click="setDrawingMode(DRAWINGMODE.SHAPES.PREDEFINED.BATHROOM)"
        />
        <SMDrawingMenuItem
          title="Stage"
          icon="highlight"
          :active="drawingMode === DRAWINGMODE.SHAPES.PREDEFINED.STAGE"
          @click="setDrawingMode(DRAWINGMODE.SHAPES.PREDEFINED.STAGE)"
        />
        <SMDrawingMenuItem
          title="Accessible"
          icon="accessible"
          @click="setDrawingMode(DRAWINGMODE.SHAPES.PREDEFINED.ACCESSIBLE)"
        />
      </SMDrawingMenuItem>
    </SMDrawingMenuItem>
    <SMDrawingMenuItem
      v-if="isEventDraftOrPaused"
      title="Background"
      icon="wallpaper"
      :active="drawingMode === DRAWINGMODE.BGIMAGE"
      @click="setDrawingMode(DRAWINGMODE.BGIMAGE)"
    />
    <SMDrawingMenuItem
      title="Stage Pin"
      icon="pin"
      :active="drawingMode === DRAWINGMODE.STAGEPIN"
      @click="setDrawingMode(DRAWINGMODE.STAGEPIN)"
    />
  </SMDrawingMenu>
</template>
<script setup lang="ts">
import SMDrawingMenu from '@/components/ui/SMDrawingMenu.vue';
import SMDrawingMenuItem from '@/components/ui/SMDrawingMenuItem.vue';
import { DRAWINGMODE, EVENTSTATUS } from '@/constants';
import Application from '@/core/application';
import { useActions, useGetters, useState } from '@/store/useStore';
import SVG from 'svg.js';
import eventbus from 'tiny-emitter/instance';
import { computed, onBeforeUnmount, onMounted, ref, watch } from 'vue';

const app = Application.instance;

const { isDrawingRowsEnabled, isDrawingTablesEnabled, isDrawingSectionsEnabled, isInsideZoneLayout } =
  useGetters('settings');

const { drawingMode } = useState('settings');

const isEventDraftOrPaused = computed(
  () => app.props.status === EVENTSTATUS.DRAFT || app.props.status === EVENTSTATUS.PAUSED
);

const menuRef = ref<InstanceType<typeof SMDrawingMenu>>();

onMounted(() => {
  SVG.on(document, 'keydown', handleKeyDown);
  eventbus.on('seatmap:add:block', setMainDrawingMode);
  eventbus.on('seatmap:add:section', setMainDrawingMode);
  eventbus.on('seatmap:add:unit', setMainDrawingMode);
  eventbus.on('drawing:cancelled', setMainDrawingMode);
});

onBeforeUnmount(() => {
  SVG.off(document, 'keydown', handleKeyDown);
  eventbus.off('seatmap:add:block', setMainDrawingMode);
  eventbus.off('seatmap:add:section', setMainDrawingMode);
  eventbus.off('seatmap:add:unit', setMainDrawingMode);
  eventbus.off('drawing:cancelled', setMainDrawingMode);
});

const { changeDrawingMode, setSelection } = useActions('settings');
const handleKeyDown = (e: KeyboardEvent) => {
  switch (e.key) {
    case 'Escape':
      if (drawingMode.value !== DRAWINGMODE.MAIN) {
        setMainDrawingMode();
        e.stopImmediatePropagation();
      }
      break;
    default:
      break;
  }
};

const setMainDrawingMode = () => {
  setDrawingMode(DRAWINGMODE.MAIN, true);
};

watch(drawingMode, (mode) => {
  if (mode === DRAWINGMODE.MAIN) {
    menuRef.value?.close();
  }
});

const setDrawingMode = (mode: string, selectionFlag = false) => {
  changeDrawingMode(mode);
  setSelection(selectionFlag);
};
</script>
